import { useSelector } from 'react-redux';
import { isWeb, navigateTo, navigationRef } from '@helpers';
import { selectTopBottomSheet, pushBottomSheet, setPreCloseAction, setCloseTargetId } from '@reducers/v2/bottomSheet/bottomSheet.slice';
import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { CLOSE_ALL_BOTTOM_SHEETS } from '@v2/pages/common/constants/base.constants';

export const useHandleBottomSheetActions = () => {
  const dispatch = useAppDispatch();
  const currentRoute = navigationRef?.current?.getCurrentRoute();
  const topBottomSheet = useSelector(selectTopBottomSheet);

  const openScreenInsideBottomSheet = ({ bottomSheetId, navigationAction }: { bottomSheetId: string; navigationAction?: () => void }) => {
    dispatch(pushBottomSheet({ id: bottomSheetId, returnRoute: currentRoute ?? null }));
    navigationAction?.();
  };

  const closeBottomSheet = ({ preCloseAction }: { preCloseAction?: () => void } = {}) => {
    if (isWeb) {
      // Store the action to be executed when animation completes
      if (preCloseAction) {
        dispatch(setPreCloseAction(preCloseAction));
      }

      if (!navigationRef.current?.canGoBack() || !topBottomSheet?.returnRoute) {
        dispatch(setCloseTargetId(CLOSE_ALL_BOTTOM_SHEETS));
        return;
      }

      if (topBottomSheet) {
        dispatch(setCloseTargetId(topBottomSheet.id));
      }
    } else {
      // On mobile, execute action immediately and navigate
      if (preCloseAction) {
        preCloseAction();
      }
      if (!navigationRef.current?.canGoBack() || !topBottomSheet?.returnRoute) {
        navigateTo(isWeb ? 'Machines' : 'Authorized');
        return;
      }
      navigationRef.current?.navigate(topBottomSheet.returnRoute);
    }
  };

  return { openScreenInsideBottomSheet, closeBottomSheet };
};
